import React, {useContext, useEffect, useReducer, useState} from 'react';
import {Form, Input, Label, Loader} from "semantic-ui-react";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import Popup from "semantic-ui-react/dist/commonjs/modules/Popup";
import Button from "semantic-ui-react/dist/commonjs/elements/Button";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import {DateTimePicker} from "react-widgets";
import moment from "moment";
import axios from "axios";
import {UserRoleContext} from "../../../Main";
import {toast, ToastContainer} from "react-toastify";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid";

const reducer = (state, action)=> {
    switch (action.type) {
        case 'theme':
            return {...state, theme: action.payload};
        case 'committee':
            return {...state, committee: action.payload};
        case 'committees':
            return {...state, committees: action.payload};
        case 'mark':
            return {...state, mark: action.payload};
        case 'marks':
            return {...state, marks: action.payload};
        case 'date':
            return {...state, date: action.payload};
        case 'openForm':
            return {...state, openForm: action.payload};
        case 'loader':
            return {...state, loader: action.payload};
        default:
            return state;

    }
};
const Bhs = ({graduationExam, getGraduationInfo}) => {
    const [themeErr, setThemeErr] = useState(false);
    const [dateErr, setDateErr] = useState(false);
    const [markErr, setMarkErr] = useState(false);
    const [committeeErr, setCommitteeErr] = useState(false);
    const {activeRole} = useContext(UserRoleContext);
    const [showMess, setShowMess] = useState(false);
    const [state, dispatch] = useReducer(reducer,{
        openForm: false,
        loader: false
    });

    useEffect(() => {
        if (graduationExam){
            dispatch({type: 'theme', payload: graduationExam.bosnianLanguageWrittenWorkTheme});
            dispatch({type: 'date', payload:graduationExam.bosnianLanguageWrittenWorkDate? new Date(graduationExam.bosnianLanguageWrittenWorkDate):null});
            dispatch({type: 'mark', payload: graduationExam.bosnianLanguageWrittenWorkMark});
            dispatch({type: 'committee', payload: graduationExam.committeeForBosnianLanguageWrittenWork});
            if(!graduationExam.bosnianLanguageWrittenWorkMark?.id){  openForm()}
        }

    },[graduationExam]);


    function handleInputChange(event, { name, value }) {
        dispatch({type: name, payload: value});
    }

    function handleDateChange(name, date) {
        dispatch({type: name, payload: date});
    }

    function openForm(){
        activeRole === "ROLE_ORGANIZER" && getCommittees();
        activeRole === "ROLE_ADMIN" && getCommitteeForAdmin();
        getMarks();

        dispatch({type: 'theme', payload: graduationExam.bosnianLanguageWrittenWorkTheme});
        dispatch({type: 'date', payload:graduationExam.bosnianLanguageWrittenWorkDate? new Date(graduationExam.bosnianLanguageWrittenWorkDate):null});
        dispatch({type: 'mark', payload: graduationExam.bosnianLanguageWrittenWorkMark});
        dispatch({type: 'committee', payload: graduationExam.committeeForBosnianLanguageWrittenWork});

        dispatch({type: 'openForm', payload: true});

    }

    function updateGraduationInfo() {
        if (!state.date || !state.mark || !state.committee) {
            toast('Niste unijeli sve podatke.');
            // if (!state.theme) { setThemeErr(true); } else { setThemeErr(false); }
            if (!state.date) { setDateErr(true); } else { setDateErr(false); }
            if (!state.mark) { setMarkErr(true); } else { setMarkErr(false); }
            if (!state.committee) { setCommitteeErr(true); } else { setCommitteeErr(false); }
        } else {
        let obj = {
            ...graduationExam,
            bosnianLanguageWrittenWorkTheme: state.theme,
            bosnianLanguageWrittenWorkDate: state.date,
            bosnianLanguageWrittenWorkMark: state.mark,
            committeeForBosnianLanguageWrittenWork: state.committee,
        };

        axios.put('/graduation-exam/edit', {...obj}).then(
            (res) => {
                getGraduationInfo();
                toast('Uspješno ste izmijenili podatke.');

            }).catch((err) => {
            console.log('err', err)
        });

        dispatch({type: 'openForm', payload: false});
            }
    }

    function getMarks(){
        axios.get('/mark/all',).then(
            (res) => {
                let marks = res.data.map((el)=>({key: el.id, text:  el.name + ' (' + el.number +')', description:  el.name, value: el})).reverse();
                dispatch({type: 'marks', payload: marks});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    function getCommittees(){

        axios.get('/committee/by-organizer',).then(
            (res) => {
                let committees = res.data.map((el)=>({key: el.key, text: (el.name), description: el.firstMember.person.lastName + ', ' + el.secondMember.person.lastName + ', ' +  el.thirdMember.person.lastName, value: el}));
                dispatch({type: 'committees', payload: committees});

            }).catch((err) => {
            console.log('err', err)
        });
    }

    //for admin
    // function getOrganizers(){
    //     dispatch({type: 'loader', payload: true});
    //     axios.get('/organizer/all',).then(
    //         (res) => {
    //             let organizers = res.data.map((el)=>({...el, key: el.id, text:el.name, value: el.id}));
    //             dispatch({type: 'organizers', payload: organizers});
    //             dispatch({type: 'loader', payload: false});
    //         }).catch((err) => {
    //         console.log('err', err)
    //     });
    // }

    function getCommitteeForAdmin(id){
        const organizerId = parseInt(localStorage.getItem('organizerId'));
        axios.get(`/committee/by-organizer-id/${organizerId}`).then(
            (res) => {
                let committees = res.data.map((el)=>({key: el.key, text: (el.name), value: el}));
                dispatch({type: 'committees', payload: committees});
            }).catch((err) => {
            console.log('err', err)
        });
    }

    return (
        <div>

            {state.loader?<div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                :<Table celled size={"small"}>
                    <Table.Header>
                        <Table.HeaderCell colSpan={state.openForm?2:1}> Pismeni rad </Table.HeaderCell>
                        {!state.openForm && <Table.HeaderCell textAlign="center" >
                            <Popup size={"small"}
                                   content='Izmijeni'
                                   trigger={
                                       <Button
                                           icon
                                           size={"tiny"}
                                           basic
                                           disabled={activeRole === "ROLE_ORGANIZER" && graduationExam.serialNumber}
                                           compact
                                           floated={"right"}
                                           onClick={openForm}
                                       >
                                           <Icon name='pencil' color={"teal"} />
                                       </Button>
                                   }
                            />
                        </Table.HeaderCell>}

                    </Table.Header>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell width={8}> <Table.HeaderCell> Tema pismenog rada </Table.HeaderCell></Table.Cell>


                            {state.openForm ? <Table.Cell ><Form size={'tiny'}><Form.Field
                                    required
                                    control={Input}
                                    placeholder="Unesite naziv teme"
                                    value={state.theme}
                                    name="theme"
                                    onChange={handleInputChange}
                                    // error={themeErr}
                                />
                                </Form></Table.Cell>:
                                <Table.Cell >{state.theme && state.theme}</Table.Cell>
                            }
                        </Table.Row>
                        <Table.Row >
                            <Table.Cell><Table.HeaderCell>
                                <Form>
                                    <Form.Field required>
                                        <label>Datum pismenog rada</label>
                                    </Form.Field>
                                </Form>
                            </Table.HeaderCell></Table.Cell>
                            {/*<Table.Cell><Table.HeaderCell> Datum pismenog rada </Table.HeaderCell></Table.Cell>*/}


                            {state.openForm ? <Table.Cell >
                                <Form size={'tiny'}>
                                    <Form.Field
                                        required
                                        error={dateErr}
                                        control={DateTimePicker}
                                        format="D. M. YYYY."
                                        placeholder="Unesite datum"
                                        name="date"
                                        value={state.date}
                                        time={false}
                                        onChange={(e) => handleDateChange('date', e)}
                                        style={{ borderWidth: '0px' }}
                                    />
                                </Form>
                            </Table.Cell>: <Table.Cell>{state.date && moment(state.date).format('D. M. YYYY.')}</Table.Cell>}
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell> <Table.HeaderCell>
                                <Form>
                                    <Form.Field required>
                                        <label>Ocjena</label>
                                    </Form.Field>
                                </Form>
                            </Table.HeaderCell></Table.Cell>
                            {/*<Table.Cell> <Table.HeaderCell>Ocjena</Table.HeaderCell></Table.Cell>*/}

                            {state.openForm ? <Table.Cell>
                                <Form size={'tiny'}>
                                    <Form.Field required>
                                        <Form.Dropdown
                                            error={markErr}
                                            clearable
                                            placeholder="Odaberite ocjenu"
                                            value={state.mark}
                                            onChange={handleInputChange}
                                            name="mark"
                                            options={state.marks}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell>: <Table.Cell >{state.mark &&  state.mark.name + ' (' + state.mark.number +')' }</Table.Cell>
                            }
                        </Table.Row>

                        <Table.Row>
                            <Table.Cell> <Table.HeaderCell>
                                <Form>
                                    <Form.Field required>
                                        <label>Komisija</label>
                                    </Form.Field>
                                </Form>
                            </Table.HeaderCell></Table.Cell>
                            {/*<Table.Cell> <Table.HeaderCell>Komisija</Table.HeaderCell></Table.Cell>*/}

                            {state.openForm ? <Table.Cell>
                                <Form size={'tiny'}>
                                    <Form.Field required>
                                        <Form.Dropdown
                                            error={committeeErr}
                                            clearable
                                            placeholder="Odaberite komisiju"
                                            value={state.committee}
                                            onChange={handleInputChange}
                                            name="committee"
                                            options={state.committees}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                </Form>
                            </Table.Cell> : <Table.Cell >{state.committee && state.committee.name + '  -  ' + state.committee.firstMember.person.firstName + ' '+ state.committee.firstMember.person.lastName + ', ' + state.committee.secondMember.person.firstName + ' ' + state.committee.secondMember.person.lastName + ', ' + state.committee.thirdMember.person.firstName + ' ' + state.committee.thirdMember.person.lastName}</Table.Cell>
                            }
                        </Table.Row>

                        {state.openForm ? <Table.Row >
                            <Table.Cell colSpan={state.openForm ? 3: 2} textAlign="right">
                                <Button size={"mini"} basic color={"teal"} onClick={updateGraduationInfo} >Sačuvaj</Button>
                                <Button size={"mini"} basic color={"black"} onClick={()=>{ dispatch({type: 'openForm', payload: false})}} >Odustani</Button>
                            </Table.Cell>

                        </Table.Row>: <Table.Row >
                            {/*<Table.Cell colSpan={state.openForm ? 3: 2} textAlign="right">*/}
                            {/*    <Button icon labelPosition='left' size="mini" basic color="black"  >*/}
                            {/*        <Icon name='download' color={"teal"} />*/}
                            {/*        Preuzmi prijavu i zapisnik*/}
                            {/*    </Button>*/}

                            {/*</Table.Cell>*/}

                        </Table.Row>}

                    </Table.Body>

                </Table>}
            <ToastContainer  />
        </div>
    );
};

export default Bhs;
